import React from 'react';
import LocationsLayout from './LocationsLayout/LocationsLayout';
import { Skeleton, Stack } from '@mui/material';
import StructureListItem from './StructureListItem';
import useTypeEntity from './useTypeEntity';
import useWatchError from '../../../../../shared/hooks/useWatchError';
import ManagerViewStore from '../ManagerViewStore/ManagerViewStore';
import { M_SECONDS_POOLING_INTERVAL_DATA } from '../../../../../service/store/Store.constants';
import useDevicesManager from '../../../../../service/device/hooks/useDevicesManager';
import { BusinessLayerGroupType } from '../../../../../redux/structure/util/getTypeFromGroup';
import EntityDashboard from './EntityDashboard/EntityDashboard';
import { WorkspaceContent } from '../../../WorkspaceAdmin/WorkspaceAdminList/WorkspaceAdminList';
import { useSearchParams } from 'react-router-dom';

function EntityBusinessLayerList() {
  const {
    type,
    childGroups,
    groupId,
    error: errorEntity,
    role,
    marketId,
  } = useTypeEntity({
    refetchOnMountOrArgChange: true,
    pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
  });

  const {
    data: devices,
    error: devicesError,
    isLoading: devicesLoading,
  } = useDevicesManager(groupId, {
    skip: !groupId || type !== 'store',
    refetchOnMountOrArgChange: true,
    pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
  });

  const error = devicesError || errorEntity;
  useWatchError(error);

  const [searchBarParams] = useSearchParams();
  const isFilterTemperatureActive =
    searchBarParams.get('alarmsActive') === 'true';
  const isFilterCommanderStatusFalling =
    searchBarParams.get('deviceStatusFailing') === 'true';

  const content =
    role === 'markets' ? (
      <WorkspaceContent />
    ) : type !== 'store' ? (
      <Stack spacing={1}>
        {childGroups?.map((entity: any) => (
          <StructureListItem
            key={entity?.id}
            entity={entity}
            isFilterTemperatureActive={isFilterTemperatureActive}
            isFilterCommanderStatusFalling={isFilterCommanderStatusFalling}
          />
        ))}
      </Stack>
    ) : (
      <>
        <ManagerViewStore devices={devices} />
        {devicesLoading && !devices.length && (
          <Skeleton variant="rectangular" width={'100%'} height={200} />
        )}
      </>
    );

  // use effect to simulate the animation
  const showRightPanel = true;

  const rightPanel = (
    <EntityDashboard workspaceId={marketId} groupId={groupId} />
  );
  return (
    <LocationsLayout
      innerContainerMaxWidth={
        type === BusinessLayerGroupType.Store ? 'xl' : 'lg'
      }
      role={role}
      showRightPanel={showRightPanel}
      rightPanel={rightPanel}
      isHorizontalLayout={type === BusinessLayerGroupType.Store}
    >
      {content}
    </LocationsLayout>
  );
}

export default EntityBusinessLayerList;
